<template>

    <div v-if="show" class="terms__container">

        <p class="terms__text">{{ $t('global_banner_cgu_update') }}</p>

        <a class="terms__btn" @click="consult">{{ $t('global_banner_cgu_update_cta') }}</a>

    </div>

</template>

<script>

import Firebase from '@/modules/firebase'
import Update from '@/modules/update'

export default {

    name: 'terms-update',

    computed: {},

    data() {
        return {
            show: false
        }
    },

    mounted() {

        Firebase.getValue('last_terms_update')
            .then(updateTime => {

                if (updateTime) {

                    const lastTime = Update.terms.acceptedTime()

                    if (!lastTime || lastTime < updateTime) {

                        this.show = true
                    }
                }

            })
            .catch(() => {
            })
    },

    methods: {

        consult() {

            window.open('/terms.html')

            Update.terms.accept()

            this.show = false

        }

    }

}
</script>

<style lang="scss" scoped>

.terms {

    &__container {

        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 8px;
        box-shadow: inset 0 -1px 0 0 rgba(0, 0, 0, 0.16);
        background-color: $midnight;
        @media screen and (min-width: $above-tablet-length) {
            position: absolute;
            border-radius: 8px;
            padding: 12px;
            bottom: 16px;
            left: 16px;
            right: 16px;
        }
    }

    &__text {
        font-size: 13px;
        font-weight: 600;
        line-height: 1.4;
        color: $white;
        text-align: start;
    }

    &__btn {
        font-size: 13px;
        font-weight: bold;
        line-height: 1.23;
        color: $aquamarine;
        min-height: 30px;
        display: flex;
        align-items: center;
        padding-left: 8px;
        cursor: pointer;
    }
}


</style>
